import React, { useState } from "react"
import { FiChevronDown, } from "react-icons/fi"
import clx from "classnames"
import toast, { Toaster } from 'react-hot-toast';
const notify = () => toast.success('Here is your toast.');

export const Profile = ({profile}) => {
    const [status, setStatus] = useState(false);
    return (
      <div  className={clx({'hidden':!profile})} >
      <div className="h-full overflow-y-auto relative dark:bg-[#16191c]">
        {/** <!-- HIDDEN COVER-->
        **/}
        <div
          className="hidden w-full h-40 overflow-hidden bg-gray-200 dark:bg-gray-500"
        ></div>
        <div className="flex gap-5 mx-10 mt-5">
          <img
            src="/images/avatars/Vector-1.png"
            className="h-20 w-20 object-contain"
          />
          <div>
            <div className="flex gap-2 items-center">
              <p
                className="text-xl font-medium text-gray-700 dark:text-white"
              >
                John Doe
              </p>
              <p className="text-gray-500 dark:text-white">@john_doe</p>
            </div>
            <div
              className="flex gap-3 items-center mb-3 text-gray-400 dark:text-gray-300"
            >
              <p>557 contacts</p>
              <p>9 mutuals</p>
            </div>
            <div className="friends flex">
              <img
                src="/images/avatars/Vector-2.png"
                className="h-10 w-10 rounded-full -ml-3 border-2 border-white"
              />
              <img
                src="/images/avatars/Vector-3.png"
                className="h-10 w-10 rounded-full -ml-3 border-2 border-white"
              />
              <img
                src="/images/avatars/Vector-4.png"
                className="h-10 w-10 rounded-full -ml-3 border-2 border-white"
              />
              <img
                src="/images/avatars/Vector-5.png"
                className="h-10 w-10 rounded-full -ml-3 border-2 border-white"
              />
              <img
                src="/images/avatars/Vector-6.png"
                className="h-10 w-10 rounded-full -ml-3 border-2 border-white"
              />
            </div>
            <div className="mt-4">
              <div
                className="font-medium text-xl dark:text-white text-gray-500"
              >
                About
              </div>
              <div className="text-gray-500 text-lg">
                If you set your goals ridiculously high and it's a
                failure, you will fail above everyone else's success.
              </div>
            </div>
            <div></div>
          </div>
        </div>
  
        <Tabs />
  
  
      </div>
  
      <button onClick={notify}>Make me a toast</button>
      <Toaster
        position="bottom-center"
        reverseOrder={false}
      />
    </div>
    )
}
  
export const Tabs = () => {
  const [tab, setTab] = useState('profile')
  const [color, setColor] = useState(1)
  return (
    <React.Fragment>
      <div
          className="border-b border-gray-200 dark:border-gray-600 dark:border-gray-700 mt-6"
        >
          <ul
            className="flex flex-wrap -mb-px text-sm font-medium text-center text-gray-500 dark:text-gray-400"
          >
            <li className="mr-2" 
            onClick={()=>setTab('profile')}
            >
              <a
                className={clx("inline-flex p-4 border-b-2 rounded-t-lg active group",tab==='profile'?'text-blue-600 border-blue-600 dark:text-blue-500 dark:border-blue-500 ':'border-transparent hover:text-gray-600 hover:border-gray-500 dark:hover:text-gray-300')}
                href="#"
                aria-current="page"
              >
                <svg
                  className={clx("w-5 h-5 mr-2",tab==='profile'?'text-blue-600 dark:text-blue-500':'text-gray-400 group-hover:text-gray-500 dark:text-gray-500 dark:group-hover:text-gray-300')}
                  aria-hidden="true"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                  xmlns="http://www.w3.org/2000/svg">
                  <path
                    fill-rule="evenodd"
                    d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-6-3a2 2 0 11-4 0 2 2 0 014 0zm-2 4a5 5 0 00-4.546 2.916A5.986 5.986 0 0010 16a5.986 5.986 0 004.546-2.084A5 5 0 0010 11z"
                    clip-rule="evenodd"
                  ></path></svg>Profile
              </a>
            </li>
            <li className="mr-2"
            onClick={()=>setTab('team')}
            
            >
              <a
                className={clx("inline-flex p-4 border-b-2 rounded-t-lg active group",tab==='team'?'text-blue-600 border-blue-600 dark:text-blue-500 dark:border-blue-500 ':'border-transparent hover:text-gray-600 hover:border-gray-500 dark:hover:text-gray-300')}
                href="#"
                aria-current="page"
              >
                <svg
                  aria-hidden="true"
                  className={clx("w-5 h-5 mr-2",tab==='team'?'text-blue-600 dark:text-blue-500':'text-gray-400 group-hover:text-gray-500 dark:text-gray-500 dark:group-hover:text-gray-300')}
                  fill="currentColor"
                  viewBox="0 0 20 20"
                  xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M5 3a2 2 0 00-2 2v2a2 2 0 002 2h2a2 2 0 002-2V5a2 2 0 00-2-2H5zM5 11a2 2 0 00-2 2v2a2 2 0 002 2h2a2 2 0 002-2v-2a2 2 0 00-2-2H5zM11 5a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V5zM11 13a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z"
                  ></path></svg>Team
              </a>
            </li>
            <li className="mr-2"
            onClick={()=>setTab('settings')}
            >
              <a
                className={clx("inline-flex p-4 border-b-2 rounded-t-lg active group",tab==='settings'?'text-blue-600 border-blue-600 dark:text-blue-500 dark:border-blue-500 ':'border-transparent hover:text-gray-600 hover:border-gray-500 dark:hover:text-gray-300')}
                href="#"
                aria-current="page"
              >
                <svg
                  aria-hidden="true"
                  className={clx("w-5 h-5 mr-2",tab==='settings'?'text-blue-600 dark:text-blue-500':'text-gray-400 group-hover:text-gray-500 dark:text-gray-500 dark:group-hover:text-gray-300')}
                  fill="currentColor"
                  viewBox="0 0 20 20"
                  xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M5 4a1 1 0 00-2 0v7.268a2 2 0 000 3.464V16a1 1 0 102 0v-1.268a2 2 0 000-3.464V4zM11 4a1 1 0 10-2 0v1.268a2 2 0 000 3.464V16a1 1 0 102 0V8.732a2 2 0 000-3.464V4zM16 3a1 1 0 011 1v7.268a2 2 0 010 3.464V16a1 1 0 11-2 0v-1.268a2 2 0 010-3.464V4a1 1 0 011-1z"
                  ></path></svg>Settings
              </a>
            </li>
            <li className="mr-2"
            onClick={()=>setTab('contacts')}
            >
              <a
                className={clx("inline-flex p-4 border-b-2 rounded-t-lg active group",tab==='contacts'?'text-blue-600 border-blue-600 dark:text-blue-500 dark:border-blue-500 ':'border-transparent hover:text-gray-600 hover:border-gray-500 dark:hover:text-gray-300')}
                href="#"
                aria-current="page"
              >
                <svg
                  className={clx("w-5 h-5 mr-2",tab==='contacts'?'text-blue-600 dark:text-blue-500':'text-gray-400 group-hover:text-gray-500 dark:text-gray-500 dark:group-hover:text-gray-300')}
                  aria-hidden="true"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                  xmlns="http://www.w3.org/2000/svg">
                  <path d="M9 2a1 1 0 000 2h2a1 1 0 100-2H9z"></path>
                  <path
                    fill-rule="evenodd"
                    d="M4 5a2 2 0 012-2 3 3 0 003 3h2a3 3 0 003-3 2 2 0 012 2v11a2 2 0 01-2 2H6a2 2 0 01-2-2V5zm3 4a1 1 0 000 2h.01a1 1 0 100-2H7zm3 0a1 1 0 000 2h3a1 1 0 100-2h-3zm-3 4a1 1 0 100 2h.01a1 1 0 100-2H7zm3 0a1 1 0 100 2h3a1 1 0 100-2h-3z"
                    clip-rule="evenodd"
                  ></path></svg>Contacts
              </a>
            </li>

            <li>
              <a
                className="inline-block p-4 text-gray-400 rounded-t-lg cursor-not-allowed dark:text-gray-500">Disabled</a
              >
            </li>
          </ul>
        </div>

        <div className={clx('m-6',{'hidden': tab!='profile' })} >
            <div
              className="text-2xl font-medium dark:text-gray-400 text-gray-700"
            >
              Preferences
            </div>
            <div className="dark:text-gray-200 text-gray-500">
              Manage your account preferences
            </div>
            <div>
              <div
                className="flex-col lg:flex-row flex justify-between items-center border-b border-gray-200 dark:border-gray-700 py-4"
              >
                <div>
                  <div className="font-medium dark:text-gray-300">Theme</div>
                  <div className="text-gray-400 dark:text-gray-500">
                    Select your app color theme
                  </div>
                </div>
                <div>
                  <div
                    className="p-1 px-3 flex items-center rounded-md border font-medium cursor-pointer">
                    <p>System</p>
                    <FiChevronDown size={23} className="h-4"/>
                  </div>
                </div>
              </div>
              <div
                className="flex-col lg:flex-row flex justify-between items-center border-b border-gray-200 dark:border-gray-700 py-4"
              >
                <div>
                  <div className="font-medium dark:text-gray-300">
                    Reaction Shortcuts
                  </div>
                  <div className="text-gray-400 dark:text-gray-500">
                    Customise your reaction shortcuts
                  </div>
                </div>
                <div>
                  <ul className="flex gap-2" >
                    <li>
                      <div
                        className={clx(color==1?'border-blue-500':'dark:border-gray-700 border-gray-300', 'shadow-md border border-2 flex items-center justify-center text-2xl p-1 rounded-md cursor-pointer' )}
                        onClick={()=>setColor(1)}
                      >
                        👋
                      </div>
                    </li>
                    <li>
                      <div
                          className={clx(color==2?'border-blue-500':'dark:border-gray-700 border-gray-300', 'shadow-md border border-2 flex items-center justify-center text-2xl p-1 rounded-md cursor-pointer' )}
                          onClick={()=>setColor(2)}        
                        >
                        👋🏻
                      </div>
                    </li>
                    <li>
                      <div
                          className={clx(color==3?'border-blue-500':'dark:border-gray-700 border-gray-300', 'shadow-md border border-2 flex items-center justify-center text-2xl p-1 rounded-md cursor-pointer' )}
                          onClick={()=>setColor(3)}
                       >
                        👋🏼
                      </div>
                    </li>
                    <li>
                      <div
                        className={clx(color==4?'border-blue-500':'dark:border-gray-700 border-gray-300', 'shadow-md border border-2 flex items-center justify-center text-2xl p-1 rounded-md cursor-pointer' )}
                        onClick={()=>setColor(4)}                      
                      >
                        👋🏽
                      </div>
                    </li>
                    <li>
                      <div
                        className={clx(color==5?'border-blue-500':'dark:border-gray-700 border-gray-300', 'shadow-md border border-2 flex items-center justify-center text-2xl p-1 rounded-md cursor-pointer' )}
                        onClick={()=>setColor(5)}                      
                      >
                        👋🏾
                      </div>
                    </li>
                    <li>
                      <div
                        className={clx(color==6?'border-blue-500':'dark:border-gray-700 border-gray-300', 'shadow-md border border-2 flex items-center justify-center text-2xl p-1 rounded-md cursor-pointer' )}
                        onClick={()=>setColor(6)}                      
                      >
                        👋🏿
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
              <div
                className="flex-col lg:flex-row flex justify-between items-center border-b border-gray-200 dark:border-gray-500 dark:border-gray-700 py-4"
              >
                <div>
                  <div className="font-medium dark:text-gray-300">
                    Emoji skin tone
                  </div>
                  <div className="text-gray-400 dark:text-gray-500">
                    Choose the default emoji skin tone
                  </div>
                </div>
                <div>
                  <ul className="flex gap-2">
                    <li>
                      <div
                        className="shadow-md border border-2 border-gray-200 dark:border-gray-500 flex items-center justify-center text-2xl p-1 rounded-md cursor-pointer"
                      >
                        😁
                      </div>
                    </li>
                    {/** <!--😲😊🙂-->
                    **/}
                    <li>
                      <div
                        className="shadow-md border border-2 border-gray-200 dark:border-gray-500 flex items-center justify-center text-2xl p-1 rounded-md cursor-pointer"
                      >
                        😮
                      </div>
                    </li>
                    <li>
                      <div
                        className="shadow-md border border-2 border-gray-200 dark:border-gray-500 flex items-center justify-center text-2xl p-1 rounded-md cursor-pointer"
                      >
                        🌹
                      </div>
                    </li>
                    <li>
                      <div
                        className="shadow-md border border-2 border-gray-200 dark:border-gray-500 flex items-center justify-center text-2xl p-1 rounded-md cursor-pointer"
                      >
                        🎉
                      </div>
                    </li>
                    <li>
                      <div
                        className="shadow-md border border-2 border-gray-200 dark:border-gray-500 flex items-center justify-center text-2xl p-1 rounded-md cursor-pointer"
                      >
                        👍
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
              <div
                className="flex-col lg:flex-row flex justify-between items-center border-b border-gray-200 dark:border-gray-700 py-4"
              >
                <div>
                  <div className="font-medium dark:text-gray-300">Theme</div>
                  <div className="text-gray-400 dark:text-gray-500">
                    Select your app color theme
                  </div>
                </div>
                <div>
                  <div
                    className="p-1 px-3 flex items-center rounded-md border font-medium cursor-pointer">
                    <p>Set in the browser</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div  className={clx('grid grid-cols-1 md:grid-cols-3 m-6 gap-5',{'hidden': tab!='team' })} >
            <div
              className="border border-gray-200 dark:border-gray-600 hover:bg-gray-100 dark:hover:bg-zinc-800 rounded-md p-10 flex flex-col items-center justify-center cursor-pointer"
            >
              <img
                src="/images/avatars/Vector-10.png"
                className="h-14 w-14"
              />
              <div>
                <div className="text-gray-500">@john_doe</div>
                <div
                  className="font-medium text-xl cursor-pointer dark:text-white text-gray-700"
                >
                  John Doe
                </div>
              </div>
            </div>
            <div
              className="border border-gray-200 dark:border-gray-600 hover:bg-gray-100 dark:hover:bg-zinc-800 rounded-md p-10 flex flex-col items-center justify-center cursor-pointer"
            >
              <img
                src="/images/avatars/Vector-11.png"
                className="h-14 w-14"
              />
              <div>
                <div className="text-gray-500">@john_doe</div>
                <div
                  className="font-medium text-xl cursor-pointer dark:text-white text-gray-700"
                >
                  John Doe
                </div>
              </div>
            </div>
            <div
              className="border border-gray-200 dark:border-gray-600 hover:bg-gray-100 dark:hover:bg-zinc-800 rounded-md p-10 flex flex-col items-center justify-center cursor-pointer"
            >
              <img
                src="/images/avatars/Vector-12.png"
                className="h-14 w-14"
              />
              <div>
                <div className="text-gray-500">@john_doe</div>
                <div
                  className="font-medium text-xl cursor-pointer dark:text-white text-gray-700"
                >
                  John Doe
                </div>
              </div>
            </div>
            <div
              className="border border-gray-200 dark:border-gray-600 hover:bg-gray-100 dark:hover:bg-zinc-800 rounded-md p-10 flex flex-col items-center justify-center cursor-pointer"
            >
              <img
                src="/images/avatars/Vector-13.png"
                className="h-14 w-14"
              />
              <div>
                <div className="text-gray-500">@john_doe</div>
                <div
                  className="font-medium text-xl cursor-pointer dark:text-white text-gray-700"
                >
                  John Doe
                </div>
              </div>
            </div>
            <div
              className="border border-gray-200 dark:border-gray-600 hover:bg-gray-100 dark:hover:bg-zinc-800 rounded-md p-10 flex flex-col items-center justify-center cursor-pointer"
            >
              <img
                src="/images/avatars/Vector-14.png"
                className="h-14 w-14"
              />
              <div>
                <div className="text-gray-500">@john_doe</div>
                <div
                  className="font-medium text-xl cursor-pointer dark:text-white text-gray-700"
                >
                  John Doe
                </div>
              </div>
            </div>
            <div
              className="border border-gray-200 dark:border-gray-600 hover:bg-gray-100 dark:hover:bg-zinc-800 rounded-md p-10 flex flex-col items-center justify-center cursor-pointer"
            >
              <img
                src="/images/avatars/Vector-15.png"
                className="h-14 w-14"
              />
              <div>
                <div className="text-gray-500">@john_doe</div>
                <div
                  className="font-medium text-xl cursor-pointer dark:text-white text-gray-700"
                >
                  John Doe
                </div>
              </div>
            </div>
            <div
              className="border border-gray-200 dark:border-gray-600 hover:bg-gray-100 dark:hover:bg-zinc-800 rounded-md p-10 flex flex-col items-center justify-center cursor-pointer"
            >
              <img
                src="/images/avatars/Vector-9.png"
                className="h-14 w-14"
              />
              <div>
                <div className="text-gray-500">@john_doe</div>
                <div
                  className="font-medium text-xl cursor-pointer dark:text-white text-gray-700"
                >
                  John Doe
                </div>
              </div>
            </div>
            <div
              className="border border-gray-200 dark:border-gray-600 hover:bg-gray-100 dark:hover:bg-zinc-800 rounded-md p-10 flex flex-col items-center justify-center cursor-pointer"
            >
              <img
                src="/images/avatars/Vector-8.png"
                className="h-14 w-14"
              />
              <div>
                <div className="text-gray-500">@john_doe</div>
                <div
                  className="font-medium text-xl cursor-pointer dark:text-white text-gray-700"
                >
                  John Doe
                </div>
              </div>
            </div>
            <div
              className="border border-gray-200 dark:border-gray-600 hover:bg-gray-100 dark:hover:bg-zinc-800 rounded-md p-10 flex flex-col items-center justify-center cursor-pointer"
            >
              <img
                src="/images/avatars/Vector-7.png"
                className="h-14 w-14"
              />
              <div>
                <div className="text-gray-500">@john_doe</div>
                <div
                  className="font-medium text-xl cursor-pointer dark:text-white text-gray-700"
                >
                  John Doe
                </div>
              </div>
            </div>
          </div>

          <div className={clx('m-6',{'hidden': tab!='settings' })} >
            <div
              className="text-2xl font-medium dark:text-gray-400 text-gray-700 mt-3"
            >
              Notifications
            </div>
            <div className="dark:text-gray-200 text-gray-500">
              Set as the default browser application for chatbox
            </div>
            <div>
              <div
                className="flex justify-between items-center border-b border-gray-200 dark:border-gray-700 py-4"
              >
                <div>
                  <div className="font-medium dark:text-gray-300">
                    Play notification sounds
                  </div>
                  <div className="text-gray-400 dark:text-gray-500">
                    Turn this off if you would like to disable all
                    notification sound effects.
                  </div>
                </div>
                <div>
                  <label
                    className="relative inline-flex items-center mb-5 cursor-pointer">
                    <input
                      type="checkbox"
                      checked="true"
                      value=""
                      className="sr-only peer"
                    />
                    <div
                      className="w-9 h-5 bg-gray-200 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600"
                    ></div>
                  </label>
                </div>
              </div>
              <div
                className="flex justify-between items-center border-b border-gray-200 dark:border-gray-700 py-4"
              >
                <div>
                  <div className="font-medium dark:text-gray-300">
                    Send notifications while I'm off
                  </div>
                  <div className="text-gray-400 dark:text-gray-500">
                    Turn this off to completely disable notificaitons
                    outside business hours
                  </div>
                </div>
                <div>
                  <label
                    className="relative inline-flex items-center mb-5 cursor-pointer">
                    <input
                      type="checkbox"
                      checked="false"
                      value=""
                      className="sr-only peer"
                    />
                    <div
                      className="w-9 h-5 bg-gray-200 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600"
                    ></div>
                  </label>
                </div>
              </div>
            </div>
          </div>

          <div className={clx({'hidden': tab!='contacts' })}
          >
            <div className="grid grid-cols-1 md:grid-cols-3 m-6 gap-5">
              <div
                className="border border-gray-200 dark:border-gray-600 hover:bg-gray-100 dark:hover:bg-zinc-800 rounded-md p-10 flex flex-col items-center justify-center cursor-pointer"
              >
                <img
                  src="/images/avatars/Vector-13.png"
                  className="h-14 w-14 rounded-full border-green-400 border-4"
                />
                <div>
                  <div className="text-gray-500">@john_doe</div>
                  <div
                    className="font-medium text-xl cursor-pointer dark:text-white text-gray-700">
                    John Doe
                  </div>
                </div>
              </div>
              <div
                className="border border-gray-200 dark:border-gray-600 hover:bg-gray-100 dark:hover:bg-zinc-800 rounded-md p-10 flex flex-col items-center justify-center cursor-pointer"
              >
                <img
                  src="/images/avatars/Vector-14.png"
                  className="h-14 w-14 rounded-full border-yellow-300 border-4"
                />
                <div>
                  <div className="text-gray-500">@john_doe</div>
                  <div
                    className="font-medium text-xl cursor-pointer dark:text-white text-gray-700">
                    John Doe
                  </div>
                </div>
              </div>
              <div
                className="border border-gray-200 dark:border-gray-600 hover:bg-gray-100 dark:hover:bg-zinc-800 rounded-md p-10 flex flex-col items-center justify-center cursor-pointer"
              >
                <img
                  src="/images/avatars/Vector-15.png"
                  className="h-14 w-14 rounded-full border-yellow-300 border-4"
                />
                <div>
                  <div className="text-gray-500">@john_doe</div>
                  <div
                    className="font-medium text-xl cursor-pointer dark:text-white text-gray-700">
                    John Doe
                  </div>
                </div>
              </div>
              <div
                className="border border-gray-200 dark:border-gray-600 hover:bg-gray-100 dark:hover:bg-zinc-800 rounded-md p-10 flex flex-col items-center justify-center cursor-pointer"
              >
                <img
                  src="/images/avatars/Vector-9.png"
                  className="h-14 w-14 rounded-full border-gray-300 border-4"
                />
                <div>
                  <div className="text-gray-500">@john_doe</div>
                  <div
                    className="font-medium text-xl cursor-pointer dark:text-white text-gray-700">
                    John Doe
                  </div>
                </div>
              </div>
              <div
                className="border border-gray-200 dark:border-gray-600 hover:bg-gray-100 dark:hover:bg-zinc-800 rounded-md p-10 flex flex-col items-center justify-center cursor-pointer"
              >
                <img
                  src="/images/avatars/Vector-8.png"
                  className="h-14 w-14 rounded-full border-gray-300 border-4"
                />
                <div>
                  <div className="text-gray-500">@john_doe</div>
                  <div
                    className="font-medium text-xl cursor-pointer dark:text-white text-gray-700">
                    John Doe
                  </div>
                </div>
              </div>
              <div
                className="border border-gray-200 dark:border-gray-600 hover:bg-gray-100 dark:hover:bg-zinc-800 rounded-md p-10 flex flex-col items-center justify-center cursor-pointer"
              >
                <img
                  src="/images/avatars/Vector-7.png"
                  className="h-14 w-14 rounded-full border-green-400 border-4"
                />
                <div>
                  <div className="text-gray-500">@john_doe</div>
                  <div
                    className="font-medium text-xl cursor-pointer dark:text-white text-gray-700">
                    John Doe
                  </div>
                </div>
              </div>
            </div>
          </div>
          
    </React.Fragment>

  )
}
